import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Book = ({ id, imgSrc, title, rating, normalPrice, salePrice }) => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  return (
    <div className="book" aria-busy={isImageLoading}>
      <a href={`/books/${id}`}>
        <figure className="book__img--wrapper">
          {isImageLoading && (
            <div className="book__img--skeleton skeleton" aria-hidden="true" />
          )}
          <img
            src={imgSrc}
            alt={`${title} cover`}
            className={`book__img ${isImageLoading ? "book__img--loading" : ""}`}
            onLoad={() => setIsImageLoading(false)}
            onError={() => setIsImageLoading(false)}
          />
        </figure>
      </a>
      <div className="book__title">
        {isImageLoading ? (
          <div className="book__title--skeleton skeleton" aria-hidden="true" />
        ) : (
          <a href={`/books/${id}`} className="book__title--link">
            {title}
          </a>
        )}
      </div>
      <div className="book__ratings" aria-hidden={isImageLoading}>
        {isImageLoading ? (
          <div className="book__rating--skeleton skeleton" aria-hidden="true" />
        ) : (
          <>
            {Array(Math.floor(rating))
              .fill()
              .map((_, i) => (
                <FontAwesomeIcon key={i} icon="star" />
              ))}
            {rating % 1 !== 0 && <FontAwesomeIcon icon="star-half" />}
          </>
        )}
      </div>
      <div className="book__price">
        {isImageLoading ? (
          <div className="book__price--skeleton skeleton" aria-hidden="true" />
        ) : salePrice != null ? (
          <>
            <span className="book__price--normal">
              ${Number(normalPrice).toFixed(2)}
            </span>
            ${Number(salePrice).toFixed(2)}
          </>
        ) : (
          `$${Number(normalPrice).toFixed(2)}`
        )}
      </div>
    </div>
  );
};

export default Book;
